import {Fragment} from 'react';

import {TokenService as Service} from './TokenService';

import {ToastService} from '../../../AppToast';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';

import {Sign} from '../../../shared/component/Sign';

import {Crup} from './component/crup';
import {ChangePassword} from './component/changePassword';
import {CreateFileCa} from './component/createFileCa';
import {CreateEASYCA} from './component/createEASYCA';
import {CreateNCCA} from './component/createNCCA';
import {CreateICA} from './component/createICA';

export const List = () => {

  const header = 'Đăng ký chứng thư số';
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'vender', header: 'Tên đơn vị cấp chứng thư số', minWidth: 200, matchMode: 'contains'},
      {field: 'subjectName', header: 'Tên chủ sở hữu', width: 180, matchMode: 'contains'},
      {field: 'serialNumber', header: 'Serial chứng thư', width: 180, matchMode: 'contains'},
      {field: 'dateFrom', header: 'Ngày có hiệu lực', width: 140, dataType: 'date'},
      {field: 'expireDate', header: 'Ngày hết hạn', width: 130, dataType: 'date'},
      {field: 'form', header: 'Hình thức', width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: Service.forms, dataType: 'fromFilterOptions'},
      {field: 'used', header: 'Sử dụng', width: 90, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean'},
      {field: 'tokenType', header: 'Loại', width: 130, matchMode: 'contains', filterType: 'dropdown', filterOptions: Service.tokenTypes, dataType: 'fromFilterOptions'},
      {field: 'defaultSign', header: 'Mặc định ký', width: 110, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const crup = Crup({header, dataKey, refreshLazyData});

  const changePassword = ChangePassword({header, dataKey, refreshLazyData});

  const createFileCa = CreateFileCa({header, dataKey, refreshLazyData});

  const createEASYCA = CreateEASYCA({header, dataKey, refreshLazyData});

  const createNCCA = CreateNCCA({header, dataKey, refreshLazyData});

  const createICA = CreateICA({header, dataKey, refreshLazyData});

  const createToken = () => {
    Sign({
      "CommandName": "TokenInfo"
    }).then((data) => {
      if (data && data.data && data.data.token) {
        const {token} = data.data;

        crup.create();

        crup.setValue({
          vender: token.Issuer,
          serialNumber: token.SerialNumber,
          subjectName: token.Subject,
          dateFrom: new Date(token.NotBefore),
          expireDate: new Date(token.NotAfter),
          form: 1,
          tokenType: 0,
          used: true
        });
      } else {
        ToastService.error('Dữ liệu không hợp lệ');
      }
    });
  }

  const {renderToolbar} = useToolbar({
    dataKey,
    reloadLazyData, selectedItems,
    otherActions: [
      {
        label: 'Thêm chứng thư số', icon: 'pi pi-fw pi-th-large', className: 'iam-toolbar iam-toolbar-success',
        items: [[
          {
            label: '',
            items: [
              {label: 'USB token', command: createToken},
              {label: 'FILE CA', command: createFileCa.open},
              {label: 'Service EASYCA', command: createEASYCA.open},
              {label: 'Service NCCA', command: createNCCA.open},
              {label: 'Service I-CA', command: createICA.open}
            ]
          }
        ]]
      },
      {
        label: 'Sửa chứng thư số', icon: 'pi pi-fw pi-pencil', className: 'iam-toolbar', command: () => {
          if (selectedItems && selectedItems['id']) {
            let item: any = selectedItems;
              if (item.dateFrom) {
                item.dateFrom = new Date(item.dateFrom);
              }
              if (item.expireDate) {
                item.expireDate = new Date(item.expireDate);
              }
              crup.update(item);
              reloadLazyData();
          } else {
            ToastService.error('Vui lòng chọn 1 chứng thư số');
          }
        }
      },
      {
        label: 'Xoá chứng thư số', icon: 'pi pi-fw pi-trash', className: 'iam-toolbar iam-toolbar-danger', command: () => {
          if (selectedItems && selectedItems['id']) {
            if (!selectedItems['used']) {
              Service.delete(selectedItems['id']).then(() => {
                ToastService.success();
                reloadLazyData();
              });
            } else {
              ToastService.error('Các chứng thư số đang tích sử dụng không được xóa');
            }
          } else {
            ToastService.error('Vui lòng chọn 1 chứng thư số');
          }
        }
      },
      {
        label: 'Đổi mật khẩu', icon: 'pi pi-fw pi-unlock', className: 'iam-toolbar iam-toolbar-help', command: () => {
          if (selectedItems && selectedItems['id']) {
            if ([1, 2, 3, 4].includes(selectedItems['tokenType'])) {
              changePassword.open(selectedItems);
            } else {
              ToastService.error('Loại chứng thư số không hỗ trợ đổi mật khẩu');
            }
          } else {
            ToastService.error('Vui lòng chọn 1 chứng thư số');
          }
        }
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {crup.render()}
      {changePassword.render()}
      {createFileCa.render()}
      {createEASYCA.render()}
      {createNCCA.render()}
      {createICA.render()}
    </Fragment>
  )
}
